module.exports = __webpack_public_path__ + "static/media/boy.896270e4.png";